var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { FilterType } from "../../model";
export class HighLighter {
    constructor(page, listener) {
        this.page = page;
        this.listener = listener;
        this.enabled = false;
        this.selectionhandler = (ev) => this.handleEvent(ev);
        // any click will trigger selection, so avoid these
        this.wasLastCollapsed = true;
        this.highlight = null;
    }
    track() {
        var _a, _b, _c;
        this.handleEvent(new Event("selectionchange"));
        // @ts-expect-error
        const Highlight = this.page.getWindow().Highlight;
        const highlightId = "auvious-cobrowser-highlight";
        if (Highlight) {
            if (!this.page.getDocument().getElementById(highlightId)) {
                const style = this.page.getDocument().createElement("style");
                style.setAttribute("id", highlightId);
                style.setAttribute("type", "text/css");
                style.innerHTML = `
        ::highlight(${highlightId}) {
          background-color: peachpuff;
        }
      `;
                (_a = this.page.filter) === null || _a === void 0 ? void 0 : _a.filterNode(style, FilterType.NoDisplay);
                this.page.getDocument().head.appendChild(style);
            }
            if (!this.highlight) {
                // clear any previous instance
                (_b = this.highlight) === null || _b === void 0 ? void 0 : _b.clear();
                (_c = this.highlight) !== null && _c !== void 0 ? _c : (this.highlight = new Highlight());
                this.page
                    .getWindow()
                    // @ts-expect-error
                    .CSS.highlights.set("auvious-cobrowser-highlight", this.highlight);
            }
        }
        this.page
            .getDocument()
            .addEventListener("selectionchange", this.selectionhandler);
        this.enabled = true;
    }
    untrack() {
        var _a;
        if (!this.enabled) {
            return;
        }
        (_a = this.page
            .getDocument()) === null || _a === void 0 ? void 0 : _a.removeEventListener("selectionchange", this.selectionhandler);
        this.enabled = false;
    }
    dispatch(_a) {
        return __awaiter(this, arguments, void 0, function* ({ ranges }) {
            let range;
            const selection = this.page.getDocument().getSelection();
            if (ranges.length) {
                range = new Range();
                const start = this.page.idp.getNode(ranges[0].startContainer);
                const end = this.page.idp.getNode(ranges[0].endContainer);
                range.setStart(start, ranges[0].startOffset);
                range.setEnd(end, ranges[0].endOffset);
            }
            this.highlight ? this.highlight.clear() : selection.removeAllRanges();
            if (range)
                this.highlight ? this.highlight.add(range) : selection.addRange(range);
        });
    }
    handleEvent(ev) {
        const selection = this.page.getWindow().getSelection();
        const range = selection.rangeCount ? selection.getRangeAt(0) : null;
        const isCollapsed = (range === null || range === void 0 ? void 0 : range.collapsed) || selection.isCollapsed;
        if (!isCollapsed) {
            this.listener({
                ranges: [
                    {
                        endContainer: this.page.idp.getId(range.endContainer),
                        endOffset: range.endOffset,
                        startContainer: this.page.idp.getId(range.startContainer),
                        startOffset: range.startOffset,
                    },
                ],
            });
        }
        else if (!this.wasLastCollapsed) {
            this.listener({
                ranges: [],
            });
        }
        this.wasLastCollapsed = isCollapsed;
    }
}
//# sourceMappingURL=highlight.js.map